import jquery from 'jquery'

// Set jQuery globally FIRST
window.jQuery = jquery
window.$ = jquery

// Configure jquery-migrate BEFORE it loads (must be set on jQuery object)
// Show warnings only in development, hide in production
const isProduction = process.env.NODE_ENV === 'production';
jquery.migrateMute = isProduction;     // Hide warnings in production only
jquery.migrateTrace = !isProduction;   // Show stack traces in development only

// Configure jQuery to include CSRF token in all AJAX requests
jquery.ajaxSetup({
  beforeSend: function(xhr, settings) {
    // Only add CSRF token for same-origin requests
    if (!this.crossDomain) {
      const token = document.querySelector('meta[name="csrf-token"]')
      if (token) {
        xhr.setRequestHeader('X-CSRF-Token', token.content)
      }
    }
  }
})

